import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { CommentIcon } from '../icons/comment-icon';
import { LikeHollowIcon } from '../icons/like-hollow-icon';
import withTranslate from '../../../common/components/with-translate/with-translate';
import styles from './post-list-classic-header.scss';
import { ViewCountIcon } from '../icons/view-count-icon';

const PostListClassicHeader = ({ t, isViewsCountEnabled, pagination }) => (
  <thead>
    <tr className={styles.row}>
      <th className={classNames(styles.titleHeader, styles.left, 'forum-text-color')}>
        {pagination}
      </th>
      <th className={classNames(styles.iconHeader, styles.right)}>
        <CommentIcon className="forum-icon-stroke" title={t('post-list-classic.comments')} />
      </th>
      <th className={classNames(styles.iconHeader, styles.right)}>
        <LikeHollowIcon className="forum-icon-stroke" title={t('post-list-classic.likes')} />
      </th>
      {isViewsCountEnabled && (
        <th className={classNames(styles.iconHeader, styles.right)}>
          <ViewCountIcon className="forum-icon-fill" title={t('post-list-classic.views')} />
        </th>
      )}
      <th className={classNames(styles.timeAgoHeader, styles.left, 'forum-text-color')}>
        {t('post-list-classic.recent-activity')}
      </th>
      <th className={styles.moreButtonHeader}>
        <span className={styles.a11yOnly}>{t('post-list-classic.table-header-more-button')}</span>
      </th>
    </tr>
  </thead>
);

PostListClassicHeader.propTypes = {
  t: PropTypes.func.isRequired,
  isViewsCountEnabled: PropTypes.bool.isRequired,
  pagination: PropTypes.any,
};

export default withTranslate(PostListClassicHeader);
